// extracted by mini-css-extract-plugin
export var nextPrevLink = "postLayout-module--nextPrevLink--07910";
export var shareCol = "postLayout-module--shareCol--59893";
export var shareRow = "postLayout-module--shareRow--e7f0b";
export var topBlogImg = "postLayout-module--topBlogImg--a3611";